export function initServiceSwiper() {
  const $ = window.jQuery;
  const $serviceFeatures = $('.service-features-container.swiper');

  if (!$serviceFeatures.length) {
    return null;
  }

  const serviceSwiper = new window.Swiper('.service-features-container.swiper', {
    direction: 'vertical',
    slidesPerView: 'auto',
    watchOverflow: true,
    observer: true,
    observeParents: true,
    // spaceBetween: 20,
    loop: true,
    lazy: true,
    speed: 1500,
    autoplay: false, // Disable autoplay on initialization
    mousewheel: {
      enabled: true,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    on: {
      slideChange: function () {
        const activeIndex = this.activeIndex;
        const slidesLength = this.slides.length;

        if (activeIndex < slidesLength / 2) {
          this.slides.forEach(slide => {
            slide.classList.remove('swiper-slide-visited');
          });
        }

        for (let i = 0; i < activeIndex; i++) {
          const slide = this.slides[i];
          slide.classList.add('swiper-slide-visited');
        }
      },
    },
  });

  $('#service-features').hover(
    () => serviceSwiper.autoplay.start(), // Start autoplay on hover
    () => serviceSwiper.autoplay.stop()  // Stop autoplay on mouse leave
  );

  return serviceSwiper;
}